import { Model } from '@contember/schema';
import { noCase } from 'change-case';
import { formatDataType, formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { SchemaDslBuilderError } from '../../SchemaDslBuilder';
export const addColumnStmtInstruction = `
#### Column Addition
- Syntax: \`add column <entity_name>.<column_name> <data_type> [required];\`
- Example: \`add column Author.name string;\`
- Example: \`add column Author.website string required;\`

Important notes:
- There are following primitive data types: string, int, float, boolean, date, datetime
- Data type can also reference an enum
- Do not use other data types then predefined primitive types or enums
`;
export const stmtAddSchemaColumn = ({ entityName, columnName, dataType, nullable }) => {
    if (nullable === false) {
        return `add column ${entityName}.${columnName} ${dataType} required;`;
    }
    return `add column ${entityName}.${columnName} ${dataType};`;
};
export const stmtForHumanAddSchemaColumn = ({ entityName, columnName, dataType, nullable }) => {
    return (`Add a new __${dataType}__ column named __${noCase(columnName)}__ to the database table __${noCase(entityName)}__.` +
        (nullable ? '' : ' The column is required.'));
};
export const dataTypesMapping = {
    boolean: Model.ColumnType.Bool,
    int: Model.ColumnType.Int,
    number: Model.ColumnType.Int,
    string: Model.ColumnType.String,
    text: Model.ColumnType.String,
    float: Model.ColumnType.Double,
    json: Model.ColumnType.Json,
    date: Model.ColumnType.Date,
    datetime: Model.ColumnType.DateTime,
    uuid: Model.ColumnType.Uuid,
};
export const addColumnHandler = createSchemaStatementHandler({
    type: 'add column',
    parse: line => {
        const match = /^(add|create) column (?<entityName>\w+)\.(?<columnName>\w+) (?<dataType>[\w_]+)(?<required> required)?/.exec(line);
        return match?.groups
            ? {
                type: 'add column',
                entityName: formatEntityName(match.groups.entityName),
                columnName: formatFieldName(match.groups.columnName),
                dataType: formatDataType(match.groups.dataType),
                nullable: !match.groups.required,
            }
            : null;
    },
    getHumanStmt: stmtForHumanAddSchemaColumn,
    apply: (stmt, builder) => {
        const builtIn = dataTypesMapping[stmt.dataType] ?? null;
        builder.updateSchema(it => {
            if (it.schema.model.entities[stmt.entityName]?.fields[stmt.columnName]) {
                it = it.removeField(stmt.entityName, stmt.columnName);
            }
            if (builtIn) {
                return it.addColumn(stmt.entityName, {
                    type: builtIn,
                    name: stmt.columnName,
                    nullable: stmt.nullable || false,
                });
            }
            if (it.schema.model.enums[stmt.dataType]) {
                return it.addColumn(stmt.entityName, {
                    type: Model.ColumnType.Enum,
                    columnType: stmt.dataType,
                    name: stmt.columnName,
                    nullable: stmt.nullable || false,
                });
            }
            throw new SchemaDslBuilderError(`Invalid column type ${stmt.dataType}`);
        });
    },
});
//# sourceMappingURL=AddColumnStmt.js.map